import { Layout } from 'src/components/layout/layout';
import Component from 'src/components/ScoringPrograms';

const ScoringPrograms = () => {
    return (
        <Layout>
            <Component />
        </Layout>
    );
};

export default ScoringPrograms;
